import { render } from "./IngredientEditor.vue?vue&type=template&id=4e31ed38&scoped=true&ts=true"
import script from "./IngredientEditor.vue?vue&type=script&lang=ts"
export * from "./IngredientEditor.vue?vue&type=script&lang=ts"

import "./IngredientEditor.vue?vue&type=style&index=0&id=4e31ed38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e31ed38"]])

export default __exports__